// Run code only after DOM is fully loaded, no delay needed

function documentContentLoaded() {
  let hideFilterBtn = document.querySelector('.filter-sidebar-title__icon');
  let hideFilterBtnText = hideFilterBtn?.querySelector('.productgrid--sidebar-title');
  let filterProdGrid = document.querySelector('.productgrid--outer');
  let filterSideBar = filterProdGrid?.querySelector('.productgrid--sidebar');
  let prodGridWrapper = filterProdGrid?.querySelector('.productgrid--wrapper');
  hideFilterBtn?.addEventListener('click', function() {
    if (filterSideBar && prodGridWrapper) {
      filterSideBar.classList.toggle('hidden');
      prodGridWrapper.classList.toggle('full-width');
      filterProdGrid.classList.toggle('active');
      hideFilterBtnText?.classList.toggle('hidden');
      if (hideFilterBtnText) {
        hideFilterBtnText.textContent = filterSideBar.classList.contains('hidden') ? 'Show Filters' : 'Hide Filters';
      }
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', documentContentLoaded);
} else {
  documentContentLoaded();
}